import React from 'react';
import PropTypes from 'prop-types';
import sanitizeHtml from 'sanitize-html';

Decorate.propTypes = {
  label: PropTypes.string,
};

function Decorate({label}) {

  if (label === undefined) {
    return null;
  }


  // replace \n and \\n by <br/>
  let formattedLabel = (
    <>
      {label.replaceAll('\\n','\n').split('\n').map((item, index, {length}) => {
        if(item.replaceAll('\n','').trim() === '')
          return null;
        return (
          <React.Fragment key={index}>
            <span dangerouslySetInnerHTML={{__html:sanitizeHtml(item)}}></span>
            {length - 1 !== index ? <br/> : null}
          </React.Fragment>
        );
      })}
    </>
  );

  return formattedLabel;
}

export default Decorate;
